const DEFAULT_API_BASE_URL = 'http://localhost:5000/api';
const DEFAULT_MAIN_APP_BASE_URL = 'http://localhost:3000';

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const envApiBaseUrl = process.env.REACT_APP_API_URL?.trim();
const envMainAppUrl = process.env.REACT_APP_MAIN_APP_URL?.trim();

export const API_BASE_URL = trimTrailingSlash(envApiBaseUrl || DEFAULT_API_BASE_URL);
export const MAIN_APP_BASE_URL = trimTrailingSlash(envMainAppUrl || DEFAULT_MAIN_APP_BASE_URL);
